import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Auth } from 'aws-amplify';


if (process.env.NODE_ENV === 'development') {
  // only require in dev mode
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    // optional: logOwnerReasons: true,
  });
}

const originalFetch = window.fetch.bind(window);

window.fetch = async (input, init = undefined) => {
  const requestUrl = typeof input === 'string' ? input : input?.url;
  const isApiRequest = typeof requestUrl === 'string' && requestUrl.startsWith('/api/');

  if (!isApiRequest) {
    return originalFetch(input, init);
  }

  const headers = new Headers(
    init?.headers || (typeof input !== 'string' && input?.headers ? input.headers : undefined)
  );

  if (!headers.has('Authorization')) {
    try {
      const session = await Auth.currentSession();
      const accessToken = session?.getAccessToken?.()?.getJwtToken?.();
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
    } catch (error) {
      // If there is no current session yet, let the request continue without auth header.
    }
  }

  return originalFetch(input, {
    ...(init || {}),
    headers,
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
    <App />
    </DndProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
